import { render, staticRenderFns } from "./OfferCardLabel.vue?vue&type=template&id=ec8fc534&scoped=true"
import script from "./OfferCardLabel.vue?vue&type=script&lang=js"
export * from "./OfferCardLabel.vue?vue&type=script&lang=js"
import style0 from "./OfferCardLabel.vue?vue&type=style&index=0&id=ec8fc534&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec8fc534",
  null
  
)

export default component.exports